import { useState } from 'react';
import type { WaterServicesAssessment } from './buildPortalViewModel';

interface WaterSectionProps {
  data: WaterServicesAssessment;
}

export function WaterSection({ data }: WaterSectionProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="portal-section portal-section--water">
      <button
        className="portal-section__toggle"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
      >
        <h3 className="portal-section__title">Hot water / water services</h3>
        <span className="portal-section__chevron" aria-hidden="true">
          {expanded ? '\u25B4' : '\u25BE'}
        </span>
      </button>

      {expanded && (
        <div className="portal-section__content">
          <div className="portal-section__row">
            <dt>Strategy</dt>
            <dd>{data.strategy}</dd>
          </div>

          <div className="portal-section__row">
            <dt>Reasoning</dt>
            <dd>{data.reasoning}</dd>
          </div>

          <div className="portal-section__row">
            <dt>Mains capacity</dt>
            <dd>
              {data.mainsCapacity.label}
              {!data.mainsCapacity.adequate && (
                <span className="portal-section__constraint"> — may limit options</span>
              )}
            </dd>
          </div>

          <div className="portal-section__row">
            <dt>Peak demand</dt>
            <dd>{data.peakDemandFit}</dd>
          </div>
        </div>
      )}
    </div>
  );
}
